// ./client/src/components/custom/customButton.jsx

import React from 'react';
import '../../styles/customButton.css';

function CustomButton({ buttonTitle, action, bgColor = '#667eea', disabled = false }) {
  return (
    <div className="shadow-button" style={{ borderColor: bgColor }}>
      <button
        className="custom-button"
        style={{ backgroundColor: disabled ? '#ccc' : bgColor }}
        onClick={action}
        disabled={disabled}
      >
        {buttonTitle}
      </button>
    </div>
  );
}

export default CustomButton;